import { getShortFormat, getLocaleFormat } from "../../../../../utils/numbers";
export default function Digit(params) {
  const {
    value,
    locale,
    shortFormat = false,
    localeStringOptions,
    otherOptions
  } = params;
  const numberCell = document.createElement('div');
  numberCell.classList.add('w5-number-cell');
  if ((value === null || value === undefined) && otherOptions !== null && otherOptions !== void 0 && otherOptions.emptyIfNull) {
    return numberCell;
  }
  let number = value;
  if (typeof number === 'string') {
    number = number.replace(',', '.');
  }
  number = Number(number);
  if (isNaN(number)) {
    return numberCell;
  }
  if (shortFormat) number = getShortFormat(number, locale);else number = getLocaleFormat(number, locale, localeStringOptions);
  numberCell.innerText = number;
  return numberCell;
}